import { Link } from "react-scroll";
const NavLinks = ({ item }) => {
  return (
    <Link
      className="links"
      to={item.path}
      spy={true}
      smooth={true}
      offset={item.name === "Contact" ? -3 : -10}
      duration={500}
      activeClass="nav-link-active"
    >
      {item.name}
    </Link>
  );
};

export default NavLinks;
